const mapPaymentMethodReport = (datasRev, datasTrans) => {
  return !datasRev
    ? []
    : datasRev.flatMap((t, index) => {
        if (t && t.segment?.paymentMethod) {
          const result = Object.entries(t.segment?.paymentMethod).map(
            ([k, p]) => {
              let numTrans = 0;
              numTrans = datasTrans[index].segment.paymentMethod[k].value;
              return {
                "Payment Method": `${p.name}`,
                Transactions: numTrans,
                "Total Revenue (THB)": p.value ?? 0,
              };
            }
          );
          return [...result];
        } else return null;
      });
};

const makePaymentMethodSummary = (datas) => {
  return datas.reduce(
    (total, row) => {
      return {
        //Ranking: "Total",
        Ranking: "Total",
        "Payment Method": "",
        Transactions: total["Transactions"] + row["Transactions"],
        "Total Revenue (THB)":
          total["Total Revenue (THB)"] + row["Total Revenue (THB)"],
      };
    },
    {
      Ranking: "Total",
      "Payment Method": "",
      Transactions: 0,
      "Total Revenue (THB)": 0,
    }
  );
};

const mapProductReport = (datas, type = "all") => {
  return !datas
    ? []
    : datas.map((t) => {
        if (type === "all") {
          return {
            product_id: t.product_id,
            "Product name": t.name,
            Transactions: t.payment.total_transaction,
            "Quantity (units)": t.payment.total_qty,
            "Total Price (THB)": t.payment.total_revenue,
          };
        } else if (type === "member") {
          return {
            product_id: t.product_id,
            "Product name": t.name,
            Transactions: t.life_time.member.total_transaction,
            "Quantity (units)": t.life_time.member.total_qty,
            "Total Price (THB)": t.life_time.member.total_revenue,
          };
        } else {
          return {
            product_id: t.product_id,
            "Product name": t.name,
            Transactions: t.life_time.guest.total_transaction,
            "Quantity (units)": t.life_time.guest.total_qty,
            "Total Price (THB)": t.life_time.guest.total_revenue,
          };
        }
      });
};

const mapCategoryReport = (datas, type = "all") => {
  return !datas
    ? []
    : datas.map((t) => {
        if (type === "all") {
          return {
            "Category name": t.name,
            Transactions: t.payment.total_transaction,
            "Quantity (units)": t.payment.total_qty,
            "Total Price (THB)": t.payment.total_revenue,
          };
        } else if (type === "member") {
          return {
            "Category name": t.name,
            Transactions: t.life_time.member.total_transaction,
            "Quantity (units)": t.life_time.member.total_qty,
            "Total Price (THB)": t.life_time.member.total_revenue,
          };
        } else {
          return {
            "Category name": t.name,
            Transactions: t.life_time.guest.total_transaction,
            "Quantity (units)": t.life_time.guest.total_qty,
            "Total Price (THB)": t.life_time.guest.total_revenue,
          };
        }
      });
};

const mapProductRevReport = (datas) => {
  return !datas
    ? []
    : datas.flatMap((t) => {
        if (t && t.segment?.product) {
          const result = Object.values(t.segment?.product).map((p) => {
            return {
              "Product name": `${p.name}`,
              Revenue: p.value ?? 0,
            };
          });
          return [...result];
        } else return null;
      });
};

const mapCategoryRevReport = (datas) => {
  return !datas
    ? []
    : datas.flatMap((t) => {
        if (t && t.segment?.product) {
          const result = Object.values(t.segment?.productCategory).map((p) => {
            return {
              "Category name": `${p.name}`,
              Revenue: p.value ?? 0,
            };
          });
          return [...result];
        } else return null;
      });
};

const makeProductSummary = (datas) => {
  return datas.reduce(
    (total, row) => {
      return {
        //Ranking: "Total",
        Ranking: "Total",
        "Product name": "",
        Transactions: total["Transactions"] + row["Transactions"],
        "Quantity (units)": total["Quantity (units)"] + row["Quantity (units)"],
        "Total Price (THB)":
          total["Total Price (THB)"] + row["Total Price (THB)"],
      };
    },
    {
      Ranking: "Total",
      "Product name": "",
      Transactions: 0,
      "Quantity (units)": 0,
      "Total Price (THB)": 0,
    }
  );
};

const makeCategorySummary = (datas) => {
  return datas.reduce(
    (total, row) => {
      return {
        //Ranking: "Total",
        Ranking: "Total",
        "Category name": "",
        Transactions: total["Transactions"] + row["Transactions"],
        "Quantity (units)": total["Quantity (units)"] + row["Quantity (units)"],
        "Total Price (THB)":
          total["Total Price (THB)"] + row["Total Price (THB)"],
      };
    },
    {
      Ranking: "Total",
      "Category name": "",
      Transactions: 0,
      "Quantity (units)": 0,
      "Total Price (THB)": 0,
    }
  );
};
const makeProductRevSummary = (datas) => {
  return datas.reduce(
    (total, row) => {
      return {
        //Ranking: "Total",
        Ranking: "Total",
        "Product name": ``,
        Revenue: total["Revenue"] + row["Revenue"],
      };
    },
    {
      Ranking: "Total",
      "Product name": ``,
      Revenue: 0,
    }
  );
};

const makeCategoryRevSummary = (datas) => {
  return datas.reduce(
    (total, row) => {
      return {
        //Ranking: "Total",
        Ranking: "Total",
        "Category name": ``,
        Revenue: total["Revenue"] + row["Revenue"],
      };
    },
    {
      Ranking: "Total",
      "Category name": ``,
      Revenue: 0,
    }
  );
};

const mapTopBigspenderReport = (datas) => {
  return !datas
    ? []
    : datas.flatMap((t) => {
        return {
          Name: `${t.firstname} ${t.lastname}`,

          "Tier.": t.tier,
          "LTV(THB)": t.ltv,
          "Total Revenue (THB)": t.payment.total_revenue,
          Trans: t.payment.total_transaction,
          "Frequent Category": t.life_time.top_frequent_category?.name,
          "Expensive Category": t.life_time.top_expense_category?.name,
          "Frequent Product": t.life_time.top_frequent_product?.name,
          "Expensive Product": t.life_time.top_expense_product?.name,
        };
      });
};

const makeTopBigspenderSummary = (datas) => {
  return datas.reduce(
    (total, row) => {
      return {
        //Ranking: "Total",
        Ranking: "Total",
        Name: "",

        "Tier.": "",
        "LTV(THB)": row["LTV(THB)"] + total["LTV(THB)"],
        "Total Revenue (THB)":
          row["Total Revenue (THB)"] + total["Total Revenue (THB)"],
        Trans: row["Trans"] + total["Trans"],
        "Frequent Category": "",
        "Expensive Category": "",
        "Frequent Product": "",
        "Expensive Product": "",
      };
    },
    {
      Ranking: "Total",
      Name: "",

      "Tier.": "",
      "LTV(THB)": 0,
      "Total Revenue (THB)": 0,
      Trans: 0,
      "Frequent Category": "",
      "Expensive Category": "",
      "Frequent Product": "",
      "Expensive Product": "",
    }
  );
};

export {
  mapPaymentMethodReport,
  makePaymentMethodSummary,
  mapProductReport,
  mapProductRevReport,
  mapCategoryReport,
  mapCategoryRevReport,
  makeCategorySummary,
  makeCategoryRevSummary,
  makeProductSummary,
  makeProductRevSummary,
  mapTopBigspenderReport,
  makeTopBigspenderSummary,
};
